import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-block lease-banner" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { row: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          sm: "7",
          cols: "12",
          class: "lease-banner__text d-flex justify-center flex-column"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "subtitle" }, " Exceptional customer service ", -1)),
            _createElementVNode("h3", null, "About " + _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", { innerHTML: _ctx.text }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          sm: "5",
          cols: "12",
          class: "lease-banner__icon"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: require('@/assets/svg/leaseBanner.svg'),
              alt: ""
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}